import LessonPlanForm from "../shared/LessonPlanForm";

interface DailyLessonPlanFormProps {
  planId?: number;
}

const DailyLessonPlanForm = ({ planId }: DailyLessonPlanFormProps) => {
  return <LessonPlanForm type="daily" planId={planId} />;
};

export default DailyLessonPlanForm;
